module.exports = __webpack_public_path__ + "img/de.22602c01.svg";